import { atom } from 'jotai';

export const isEmbedAtom = atom(window.location?.pathname?.startsWith?.('/embed'));
